import { useEffect, useState } from "react";
import { CheckCircle2, XCircle, RefreshCw } from "lucide-react";
import { api } from "../lib/api";
import { Card, PageTitle, Btn } from "./ui";

const Row = ({ label, ok, detail, testid }) => (
  <div className="flex items-center justify-between border-b border-white/5 py-3 last:border-0" data-testid={testid}>
    <span className="flex items-center gap-3 text-sm text-white">{ok ? <CheckCircle2 size={17} className="text-emerald-400" /> : <XCircle size={17} className="text-red-400" />}{label}</span>
    <span className="text-xs text-zinc-500">{detail}</span>
  </div>
);

const Meter = ({ label, value }) => (
  <div>
    <div className="flex justify-between text-sm"><span className="text-zinc-400">{label}</span><span className="text-white">{value}%</span></div>
    <div className="mt-2 h-2 rounded-full bg-white/5"><div className={`h-2 rounded-full ${value > 85 ? "bg-red-500" : value > 65 ? "bg-amber-400" : "bg-[#D4AF37]"}`} style={{ width: `${value}%` }} /></div>
  </div>
);

const fmt = (s) => `${Math.floor(s / 86400)}d ${Math.floor((s % 86400) / 3600)}h ${Math.floor((s % 3600) / 60)}m`;

export default function Health() {
  const [h, setH] = useState(null);
  const load = () => { setH(null); api.get("/admin/health").then(({ data }) => setH(data)); };
  useEffect(() => { load(); }, []);

  return (
    <div data-testid="admin-health">
      <PageTitle title="System Health" sub={h ? `Last checked ${new Date(h.checked_at).toLocaleTimeString()}` : "Checking…"}>
        <Btn variant="outline" onClick={load} data-testid="health-refresh"><RefreshCw size={14} /> Refresh</Btn>
      </PageTitle>
      {!h ? <p className="text-zinc-500">Running checks…</p> : (
        <div className="grid gap-6 lg:grid-cols-2">
          <Card title="Services">
            <Row label="API server" ok detail={`Uptime ${fmt(h.uptime_seconds)}`} testid="health-api" />
            <Row label="Database" ok={h.database.ok} detail={`${h.database.latency_ms} ms`} testid="health-db" />
            <Row label="Image storage" ok={h.storage.ok} detail={h.storage.ok ? "Connected" : "Unavailable"} testid="health-storage" />
            <Row label="AI key" ok={h.ai_key.ok} detail={h.ai_key.ok ? "Configured" : "Missing"} testid="health-ai" />
          </Card>
          <Card title="Server resources">
            <div className="space-y-5"><Meter label="CPU" value={h.cpu_percent} /><Meter label="Memory" value={h.memory_percent} /><Meter label="Disk" value={h.disk_percent} /></div>
          </Card>
          <Card title="Content & data" className="lg:col-span-2">
            <div className="grid grid-cols-2 gap-4 sm:grid-cols-5">
              {Object.entries(h.counts).map(([k, v]) => (
                <div key={k} data-testid={`health-count-${k}`}><p className="font-serif text-2xl font-bold text-white">{v}</p><p className="text-xs uppercase tracking-wider text-zinc-500">{k.replace("_", " ")}</p></div>
              ))}
            </div>
          </Card>
        </div>
      )}
    </div>
  );
}
